export default __webpack_public_path__ + "static/media/bg_home.a29462ae.png";